module.exports = __webpack_public_path__ + "static/media/limit-white.c8949877.svg";